export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zeichenfolge von"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bis"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zeichen"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ungültiger Wert"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erforderliches Feld"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Überprüfen Sie die Felder"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SVG, PNG oder JPG"])}
}